import React from 'react';
import pt from 'prop-types';
import {FormSpy} from 'react-final-form';
import validations from './utils/validations';
import {hasBadCharacters} from './utils/validations';

const MarketoValidationEngine = ({fieldGroups = [], setFormValid, setFieldData, requiredError, getFieldState}) => {
    return (
        <FormSpy
            subscription={{values: true}}
            onChange={({values}) => {
                let allValid = true;
                fieldGroups.forEach(group => {
                    const fields = group.fields || [];
                    fields.forEach(field => {
                        if (!field.id) return;

                        //if hidden skip validation
                        const meta = getFieldState(field.id) || {};
                        const metaData = meta.data || {};
                        if (metaData.hidden) return null; //toggled hidden
                        if (typeof metaData.hidden === 'undefined' && field.initHidden) return null; //initialize hidden

                        const validationArray = field.validationArray || [];
                        const unCheckedValue = values[field.id]; //for selects it can be an object or array
                        let value = unCheckedValue;
                        if (unCheckedValue && typeof unCheckedValue === 'object' && !unCheckedValue.length && typeof unCheckedValue.value !== 'undefined') {
                            value = unCheckedValue.value;
                        } else if (unCheckedValue && typeof unCheckedValue === 'object' && unCheckedValue.length) {
                            value = unCheckedValue[0].value;
                        }

                        let valid = true;
                        let error = requiredError || ['errors.com.epicgames.validation.required'];

                        if (value && field.maxLength && value.toString().length > field.maxLength) {
                            valid = false;
                            error = ['errors.com.epicgames.validation.max_length', field.maxLength];
                        }

                        if (valid && value) {
                            if (hasBadCharacters(value)) {
                                valid = false;
                                error = ['errors.com.epicgames.validation.invalid.alphanum'];
                            }
                        }

                        if (valid) {
                            validationArray.forEach(key => {
                                if (valid && key === 'required') {
                                    if (value === null || typeof value === 'undefined' || value.toString().length < 1) {
                                        valid = false;
                                    } else if (field.type === 'checkbox' && (value === false)) {
                                        valid = false;
                                    }
                                } else if (valid && value && key) {
                                    const validatorFn = validations[key];
                                    if (validatorFn && typeof validatorFn === 'function') {
                                        const validation = validatorFn(value) || {};
                                        valid = validation.valid;
                                        error = validation.error;
                                    }
                                }
                            });

                            //check if marked required in metadata
                            if (valid && metaData.required === true && (value === null || typeof value === 'undefined' || value.toString().length < 1)) {
                                valid = false;
                            }
                        }

                        if (!valid) allValid = false;

                        setFieldData(field.id, {valid, error});
                    });
                });
                setFormValid(allValid);
            }}
        />

    );
};

MarketoValidationEngine.propTypes = {
    fieldGroups: pt.array,
    setFormValid: pt.func,
    setFieldData: pt.func,
    requiredError: pt.string,
    getFieldState: pt.func.isRequired
};

export default MarketoValidationEngine;
